module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "user-profile"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('table', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tried_problems), function(item) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/problem/" + (item.uid) + "/")
      }
    }, [_vm._v(_vm._s(item.uid))])], 1), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_vm._v(_vm._s(item.result))])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, [_c('h2', {
    staticClass: "col"
  }, [_vm._v("Tried Problems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Result")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40111e3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserProfile.vue
// module id = 578
// module chunks = 0